(() => {
  'use strict';
  const root = document.querySelector('[data-cgk-guide]');
  if (!root) return;
  const guideId = root.dataset.cgkGuide;
  const productHandle = root.dataset.productHandle;
  const parameters = new URLSearchParams(location.search);
  const approvedParameter = key => /^(utm_[a-z0-9_]+|nb_[a-z0-9_]+|nbt|dicbo|ob_click_id|outbrain_click_id|_ob_click_id|gclid|fbclid|msclkid)$/i.test(key);
  const decorateLinks = () => {
    root.querySelectorAll('a[data-guide-product]').forEach(link => {
      const destination = new URL(link.getAttribute('href'), location.origin);
      if (destination.origin !== location.origin || destination.pathname !== '/products/' + productHandle) return;
      const keys = [...new Set([...parameters.keys()].filter(approvedParameter))];
      keys.forEach(key => {
        destination.searchParams.delete(key);
        parameters.getAll(key).forEach(value => destination.searchParams.append(key, value));
      });
      destination.searchParams.set('cgk_lp', guideId);
      link.href = destination.href;
    });
  };
  decorateLinks();
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  let viewed = false;
  let productClicked = false;
  const emit = (name, properties) => {
    if (!allowed()) return false;
    const payload = { guide_id: guideId, guide_layout: root.dataset.guideLayout, product_handle: productHandle, ...properties };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...payload });
    if (typeof window.Shopify?.analytics?.publish === 'function') {
      try { Promise.resolve(window.Shopify.analytics.publish(name, payload)).catch(() => {}); } catch (_) {}
    }
    return true;
  };
  const pageView = () => { if (!viewed) viewed = emit('cgk_guide_view', {}); };
  if (window.Shopify?.loadFeatures && !window.Shopify.customerPrivacy) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) pageView(); });
  } else pageView();
  document.addEventListener('visitorConsentCollected', pageView);
  root.addEventListener('click', event => {
    const link = event.target.closest('a[data-guide-product]');
    if (link && !productClicked) productClicked = emit('cgk_guide_product_click', { placement: link.dataset.guideProduct || 'body' });
  });
  const milestones = new Set();
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const milestone = entry.target.dataset.guideMilestone;
        if (entry.isIntersecting && !milestones.has(milestone) && emit('cgk_guide_depth', { milestone })) milestones.add(milestone);
      });
    }, { threshold: 0.35 });
    root.querySelectorAll('[data-guide-milestone]').forEach(element => observer.observe(element));
    const sticky = root.querySelector('.cgk-guide-sticky');
    const hero = root.querySelector('.cgk-guide-hero');
    const footer = document.querySelector('.cgk-guide-footer');
    let pastHero = false, atFooter = false;
    const updateSticky = () => {
      const visible = pastHero && !atFooter;
      sticky?.classList.toggle('is-visible', visible);
      if (sticky) { sticky.inert = !visible; sticky.setAttribute('aria-hidden', String(!visible)); }
    };
    new IntersectionObserver(entries => {
      pastHero = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom <= 0;
      updateSticky();
    }).observe(hero);
    if (footer) new IntersectionObserver(entries => { atFooter = entries[0].isIntersecting; updateSticky(); }).observe(footer);
  }
})();
